<template>
  <div id="diaodu12223">
    <Steps :current="2" direction="vertical">
      <Step icon="ios-car">
        <p slot="title">派遣车辆</p>
        <p
          slot="content"
          class="dispatchTitle"
          @click="
            showCar = !showCar;
            showDriver = false;
          "
        >
          {{ dispatchItem.carNo }}
          <span style="color:#ccc">{{dispatchItem.carGroup}}</span>
        </p>
        <div v-show="showCar" slot="content">
          <Input
            search
            v-model="carKeyword"
            placeholder="搜索车辆/单位"
            @on-search="getCarList"
            clearable
            enter-button
          ></Input>
          <ul class="dispatchUl gundongtiao">
            <li
              v-for="(item, index) in dispatchItem.carList"
              :key="index"
              @click="selectCar(item)"
            >
              <span class="title">{{ item.carNo }} </span>
              <span style="float: right; color: red"
                >任务({{ item.taskNum }})</span
              >
              <p class="group">{{ item.groupName }}</p>
            </li>
            <li v-if="dispatchItem.carList.length == 0">暂无车辆</li>
          </ul>
        </div>
      </Step>
      <Step icon="ios-person">
        <p slot="title">派遣司机</p>
        <p
          slot="content"
          class="dispatchTitle"
          @click="
            showDriver = !showDriver;
            showCar = false;
          "
        >
          {{ dispatchItem.driver }}
          <span style="color:#ccc">{{dispatchItem.driverGroup}}</span>
        </p>
        <div v-show="showDriver" slot="content">
          <Input
            search
            v-model="driverKeyword"
            placeholder="搜索司机/单位"
            @on-search="getDriverList"
            clearable
            enter-button
          ></Input>
          <ul class="dispatchUl gundongtiao">
            <li
              v-for="(item, index) in dispatchItem.driverList"
              :key="index"
              @click="selectDriver(item)"
            >
              <span class="title">{{ item.name }} </span>
              <span style="float: right; color: red"
                >任务({{ item.taskNum }})</span
              >
              <p class="group">{{ item.groupName }}</p>
            </li>
            <li v-if="dispatchItem.driverList.length == 0">暂无司机</li>
          </ul>
        </div>
      </Step>
      <Step icon="logo-yen">
        <p slot="title">计费方式</p>
        <RadioGroup v-model="dispatchItem.settleTypeId" slot="content">
          <Radio
            v-for="(item, index) in dispatchItem.settleTypeList"
            :key="index"
            :label="item.settleTypeId"
            >{{ item.name }}</Radio
          >
        </RadioGroup>
      </Step>
    </Steps>
    <Row :gutter="4" style="margin-top: 30px">
      <Col span="12">
        <Button long @click="cancel">取消</Button>
      </Col>
      <Col span="12">
        <Button
          type="primary"
          :disabled="
            dispatchItem.carId.length == 0 || dispatchItem.driverId.length == 0
          "
          long
          @click="doDispatch"
          >确定</Button
        >
      </Col>
    </Row>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      dispatchItem: {
        driverId: "",
        carList: [],
        carNo: "请选择车辆",
        carGroup:'',
        carId: "",
        driverList: [],
        driver: "请选择司机",
        driverGroup:'',
        settleTypeList: [],
        settleTypeId: "",
      },
      showCar: true,
      showDriver: false,
      carKeyword: "",
      driverKeyword: "",
    };
  },
  methods: {
    //点击确定按钮派车
    doDispatch() {
      this.$emit("dispatchData", this.dispatchItem);
    },
    //获取车辆信息
    getCarList(id) {
      axios({
        method: "post",
        url: axios.dispatch + "/dispatch/carList",
        data: {
          keyword: this.carKeyword,
        },
      }).then((res) => {
        this.dispatchItem.carList = res.data.data;
      });
    },
    //获取车辆信息
    getDriverList(id) {
      axios({
        method: "post",
        url: axios.dispatch + "/dispatch/driverList",
        data: {
          keyword: this.driverKeyword,
        },
      }).then((res) => {
        this.dispatchItem.driverList = res.data.data;
      });
    },
    //获取计费方式
    getSettleTypeList() {
      axios({
        method: "post",
        url: axios.dispatch + "/ruleCost/list",
        data: {},
      }).then((res) => {
        var data = res.data.data.dataList;
        this.dispatchItem.settleTypeList = data;
        this.dispatchItem.settleTypeId = data[0].settleTypeId;
      });
    },
    //点击车辆列表，将车填到派遣车辆
    selectCar(item) {
      this.dispatchItem.carId = item.carId;
      this.dispatchItem.carNo = item.carNo;
      this.dispatchItem.carGroup = item.groupName;
      this.showCar = false;
    },
    //点击司机列表，将车填到派遣车辆
    selectDriver(item) {
      this.dispatchItem.driverId = item.driverId;
      this.dispatchItem.driver = item.name;
      this.dispatchItem.driverGroup = item.groupName;
      this.showDriver = false;
    },
    cancel() {
      this.dispatchItem = {
        userGroupName: "请选择单位",
        driverId: "",
        carList: [],
        carNo: "请选择车牌号",
        carId: "",
        driverList: [],
        driver: "请选择司机",
        settleTypeList: [],
        settleTypeId: "",
        settleType: "请选择计费类型",
      };
      this.$emit("cancel");
    },
  },
  mounted() {
    this.getSettleTypeList();
    this.getDriverList();
    this.getCarList();
  },
  watch: {
    carKeyword(v) {
      if (v.length == 0) {
        this.getCarList();
      }
    },
    driverKeyword(v) {
      if (v.length == 0) {
        this.getDriverList();
      }
    },
  },
};
</script>
<style lang="">
.dispatchTitle {
  cursor: default;
  color: #333;
  margin-bottom: 10px;
}
.dispatchTitle:hover {
  cursor: pointer;
  color: #fa2222;
}
.dispatchUl {
  line-height: 2.5;
  margin-top: 10px;
  border: solid 1px #ddd;
  padding: 4px 0px;
  max-height: 300px;
  overflow: auto;
}
.dispatchUl li {
  list-style: outside;
  padding: 4px 10px;
}
.dispatchUl li span.title {
  color: #333;
}
.dispatchUl li p.group {
  color: #999;
  line-height: 1;
}
.dispatchUl li:hover {
  cursor: pointer;
  background: #e4f3ff;
}
#asdfasdfas {
  width: 180px;
  height: 40px;
  position: relative;
}
#asdfwer {
  width: 100%;
  height: 300px;
  background: #fff;
  position: absolute;
  top: 36px;
  z-index: 122;
  border: solid #ddd 1px;
  padding: 10px;
}
#diaodu12223 .ivu-input-wrapper:hover .ivu-input-icon-clear {
  display: inline-block;
  margin-right: 50px;
}
</style>


// WEBPACK FOOTER //
// src/components/dispatch/send.vue